// extracted by mini-css-extract-plugin
export default {"link":"AuthBtn_link__XQK6T"};